import z from 'zod';
import { timestampSchema } from './commonSchemas.js';
export const fileArchiveDefSchema = z.object({
    id: z.number().int().positive(),
    organization_id: z.number().int().nonnegative().default(0),
    file_path: z.string().max(255).optional(),
    file_name: z.string().max(255).describe('Nome del file (es: "documento.pdf")'),
    file_type: z.string().max(50).describe('Tipo MIME del file (es: "image/png", "application/pdf")'),
    file_size: z.number().int().positive().describe('Dimensione del file in byte'),
    label: z.string().max(255).optional().nullable().describe('Etichetta descrittiva del file (es: "Documento di identità")'),
    description: z.string().optional().nullable().describe('Descrizione opzionale del file'),
    tags: z.array(z.string()).default([]).describe('Array di tag per classificazione (es: ["documento", "identità", "sindacato"])'),
    /** Data di creazione del bonus */
    created_at: timestampSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    /** Data di ultima modifica del bonus */
    updated_at: timestampSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
export const fileArchiveDefSchemaNoId = fileArchiveDefSchema.omit({ id: true, created_at: true, updated_at: true });
export const fileArchiveDefSchemaInfo = fileArchiveDefSchema.extend({
    exists: z.boolean().default(false).describe('Indica se il file esiste effettivamente nel filesystem o storage')
});
// non serve lo schema per la view perché non è prevista
//# sourceMappingURL=fileArchiveDefSchema.js.map